import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "newloading-content" }
const _hoisted_2 = { class: "newloading-text" }

import { reactive } from 'vue'

interface Props {
    visible?: boolean
    fullscreen?: boolean
    text?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'loadingComp',
  props: {
    visible: { type: Boolean, default: true },
    fullscreen: { type: Boolean, default: false },
    text: { default: '' }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

// 全局状态管理
const globalState = reactive({
    visible: false
})

// 暴露给外部使用的方法
__expose({
    show: () => {
        globalState.visible = true
    },
    hide: () => {
        globalState.visible = false
    },
    globalState
})

return (_ctx: any,_cache: any) => {
  return (props.visible || globalState.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['newloading-container', { 'fullscreen': props.fullscreen }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 200 200",
            class: _normalizeClass(['pencil', { 'pencil-small': !props.fullscreen }])
          }, [...(_cache[0] || (_cache[0] = [
            _createStaticVNode("<defs data-v-0d7fec13><clipPath id=\"pencil-eraser\" data-v-0d7fec13><rect height=\"30\" width=\"30\" ry=\"5\" rx=\"5\" data-v-0d7fec13></rect></clipPath></defs><circle transform=\"rotate(-113,100,100)\" stroke-linecap=\"round\" stroke-dashoffset=\"439.82\" stroke-dasharray=\"439.82 439.82\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" r=\"70\" class=\"pencil__stroke\" data-v-0d7fec13></circle><g transform=\"translate(100,100)\" class=\"pencil__rotate\" data-v-0d7fec13><g fill=\"none\" data-v-0d7fec13><circle transform=\"rotate(-90)\" stroke-dashoffset=\"402\" stroke-dasharray=\"402.12 402.12\" stroke-width=\"30\" stroke=\"hsl(223,90%,50%)\" r=\"64\" class=\"pencil__body1\" data-v-0d7fec13></circle><circle transform=\"rotate(-90)\" stroke-dashoffset=\"465\" stroke-dasharray=\"464.96 464.96\" stroke-width=\"10\" stroke=\"hsl(223,90%,60%)\" r=\"74\" class=\"pencil__body2\" data-v-0d7fec13></circle><circle transform=\"rotate(-90)\" stroke-dashoffset=\"339\" stroke-dasharray=\"339.29 339.29\" stroke-width=\"10\" stroke=\"hsl(223,90%,40%)\" r=\"54\" class=\"pencil__body3\" data-v-0d7fec13></circle></g><g transform=\"rotate(-90) translate(49,0)\" class=\"pencil__eraser\" data-v-0d7fec13><g class=\"pencil__eraser-skew\" data-v-0d7fec13><rect height=\"30\" width=\"30\" ry=\"5\" rx=\"5\" fill=\"hsl(223,90%,70%)\" data-v-0d7fec13></rect><rect clip-path=\"url(#pencil-eraser)\" height=\"30\" width=\"5\" fill=\"hsl(223,90%,60%)\" data-v-0d7fec13></rect><rect height=\"20\" width=\"30\" fill=\"hsl(223,10%,90%)\" data-v-0d7fec13></rect><rect height=\"20\" width=\"15\" fill=\"hsl(223,10%,70%)\" data-v-0d7fec13></rect><rect height=\"20\" width=\"5\" fill=\"hsl(223,10%,80%)\" data-v-0d7fec13></rect><rect height=\"2\" width=\"30\" y=\"6\" fill=\"hsla(223,10%,10%,0.2)\" data-v-0d7fec13></rect><rect height=\"2\" width=\"30\" y=\"13\" fill=\"hsla(223,10%,10%,0.2)\" data-v-0d7fec13></rect></g></g><g transform=\"rotate(-90) translate(49,-30)\" class=\"pencil__point\" data-v-0d7fec13><polygon points=\"15 0,30 30,0 30\" fill=\"hsl(33,90%,70%)\" data-v-0d7fec13></polygon><polygon points=\"15 0,6 30,0 30\" fill=\"hsl(33,90%,50%)\" data-v-0d7fec13></polygon><polygon points=\"15 0,20 10,10 10\" fill=\"hsl(223,10%,10%)\" data-v-0d7fec13></polygon></g></g>", 3)
          ]))], 2)),
          _createElementVNode("div", _hoisted_2, _toDisplayString(props.text), 1),
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})